import { Pipe, PipeTransform } from '@angular/core';


//now using object EventObjectTypePipe

@Pipe({name: 'objectType'})
export class ObjectTypePipe implements PipeTransform {
  transform(level: number): string {
    switch(level) {
      case 1: {
        return 'Site';
      }
      case 2: {
        return 'Device';
      }
      case 3: {
        return 'Digital input';
      }
      case 4: {
        return 'Digital output';
      }
      case 5: {
        return 'Analogue input';
      }
      default: {
        return 'Unknown';
      }
    }
  }
}